import DatePicker from "react-multi-date-picker";
import "react-multi-date-picker/styles/layouts/prime.css";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import opacity from "react-element-popper/animations/opacity";

import { Range } from "rc-slider";
import "rc-slider/assets/index.css";

function FilterModal({ filterInputs, setFilterInputs, priceOptions, search }) {
  return (
    <>
      {/* filter modal */}
      <div
        className="modal fade"
        id="filterModal"
        aria-labelledby="filterModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title color-green" id="Label">
                فیلتر تورها
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="row m-2">
                <div className="col-3">
                  <label htmlFor="titleTour" className="form-label">
                    نام تور:
                  </label>
                </div>
                <div className="col-9">
                  <input
                    type="text"
                    id="titleTour"
                    className="form-control"
                    value={filterInputs.title}
                    onChange={(e) =>
                      setFilterInputs({
                        ...filterInputs,
                        title: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="row m-2">
                <div className="col-3">
                  <label htmlFor className="form-label">
                    قیمت:
                  </label>
                </div>
                <div className="col-9 position-relative ">
                  <Range
                    allowCross={false}
                    value={filterInputs.priceRange}
                    min={0}
                    max={priceOptions.max}
                    step={priceOptions.step}
                    reverse
                    onChange={(value) => {
                      setFilterInputs({
                        ...filterInputs,
                        priceRange: value,
                      });
                    }}
                  />
                  <div className="d-flex">
                    از
                    <div className="mx-1">
                      {filterInputs.priceRange[0]}
                      تومان
                    </div>
                    <div>تا</div>
                    <div className="mx-1">
                      {filterInputs.priceRange[1]}
                      تومان
                    </div>
                  </div>
                </div>
              </div>
              <div className="row m-2">
                <div className="col-3">
                  <label htmlFor="transfer" className="form-label">
                    ترنسفر:
                  </label>
                </div>
                <div className="col-9">
                  <select
                    className="form-select"
                    value={filterInputs.transferType}
                    onChange={(e) =>
                      setFilterInputs({
                        ...filterInputs,
                        transferType: e.target.value,
                      })
                    }
                  >
                    <option value={0} selected>
                      همه
                    </option>
                    <option value={1}>هوایی</option>
                    <option value={2}>زمینی</option>
                    <option value={3}>ریلی</option>
                  </select>
                </div>
              </div>
              <div className="row m-2">
                <div className="col-3">
                  <label>چندروزه:</label>
                </div>
                <div className="col-9">
                  <select
                    className="form-select"
                    value={filterInputs.duration}
                    onChange={(e) =>
                      setFilterInputs({
                        ...filterInputs,
                        duration: e.target.value,
                      })
                    }
                  >
                    <option value={0} selected>
                      همه
                    </option>
                    <option value={1}>یک روزه</option>
                    <option value={2}>دو روزه</option>
                    <option value={3}>چند روزه</option>
                  </select>
                </div>
              </div>
              <div className="row m-2">
                <div className="col-3">
                  <label htmlFor="fromDate" className="form-label ">
                    تاریخ شروع:
                  </label>
                </div>
                <div className="col-9">
                  <DatePicker
                    calendar={persian}
                    id="fromDate"
                    locale={persian_fa}
                    animations={[opacity()]}
                    style={{
                      width: "100%",
                      boxSizing: "border-box",
                      height: "26px",
                      padding: "20px 10px",
                    }}
                    containerStyle={{
                      width: "100%",
                    }}
                    onChange={(e) =>
                      setFilterInputs({ ...filterInputs, stm: e.unix })
                    }
                  />
                </div>
              </div>
              <div className="row m-2">
                <div className="col-3">
                  <label htmlFor="toDate" className="form-label  date">
                    تاریخ پایان:
                  </label>
                </div>
                <div className="col-9">
                  <DatePicker
                    calendar={persian}
                    id="toDate"
                    locale={persian_fa}
                    animations={[opacity()]}
                    style={{
                      width: "100%",
                      boxSizing: "border-box",
                      height: "26px",
                      padding: "20px 10px",
                    }}
                    containerStyle={{
                      width: "100%",
                    }}
                    onChange={(e) =>
                      setFilterInputs({ ...filterInputs, ftm: e.unix })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="align-self-center m-2">
              <button
                type="button"
                className="btn btn-success px-5"
                data-bs-dismiss="modal"
                onClick={search}
              >
                ثبت
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export { FilterModal };
